import { CreditCard, EnterpriseOrganization, Grid, Settings } from '@/assets/icons'

import type { SettingsSection } from './settings-modal-types'

/**
 * Left-nav sections currently available in the settings modal, in display order.
 *
 * This is the shipped subset, not the full design. It intentionally starts at Preferences; Profile
 * (and any other designed sections) are added here once their panels exist. Group 1 holds the
 * account-wide sections; group 2 (below the divider) holds the role-specific options — Subscription
 * for an organization account and Create organization for an individual account.
 *
 * Static UI configuration (not app state) so the shell is self-contained. Consumers that need a
 * different set — e.g. hiding a group-2 option per account type — can pass their own array to
 * `SettingsModal`.
 */
export const SETTINGS_SECTIONS: SettingsSection[] = [
  { id: 'preferences', label: 'Preferences', icon: Settings, group: 1 },
  { id: 'connected-accounts', label: 'Connected accounts', icon: Grid, group: 1 },
  { id: 'subscription', label: 'Subscription', icon: CreditCard, group: 2 },
  { id: 'create-organization', label: 'Create organization', icon: EnterpriseOrganization, group: 2 },
]
